import { motion } from "framer-motion";

const CARDS = [
  {
    title: "Sprouted 7-Millet Powerhouse",
    desc: "Barnyard, kodo, little, foxtail, browntop, proso and ragi — sprouted for 48 hours to unlock maximum protein and bioavailability.",
    span: "col-span-12 md:col-span-8 md:row-span-2",
    cls: "bg-ragi text-cream",
    img: "https://images.unsplash.com/photo-1788692944110-130f3ef845ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxtaWxsZXQlMjBncmFpbiUyMG9yZ2FuaWMlMjBmb29kJTIwYm93bHxlbnwwfHx8fDE3OTEwMTg4MzR8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Artisanal Chocolates & Truffles",
    desc: "Hand-moulded 3D chocolates, bounty bars and roasted almond fudge — no hydrogenated oils, ever.",
    span: "col-span-12 md:col-span-4",
    cls: "bg-terracotta-subtle text-ragi-dark",
    img: "https://images.unsplash.com/photo-1549007994-cb92caebd54b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxhcnRpc2FuJTIwY2hvY29sYXRlJTIwdHJ1ZmZsZXMlMjBkYXJrJTIwY29jb2F8ZW58MHx8fHwxNzkxMDE4ODM0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Authentic Tirunelveli Halwa",
    desc: "Whole-wheat milk extract slow-stirred with pure cow ghee and cardamom.",
    span: "col-span-12 md:col-span-4",
    cls: "bg-saffron-subtle text-ragi-dark",
    img: "https://images.pexels.com/photos/14774070/pexels-photo-14774070.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export default function Bento() {
  return (
    <section id="why-us" className="bg-cream py-20 sm:py-28" data-testid="bento-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mb-14 max-w-2xl"
        >
          <p className="mb-3 font-mono text-xs uppercase tracking-[0.22em] text-terracotta">Why Kandula</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-ragi-dark" data-testid="bento-title">
            Heritage wisdom, modern nutrition
          </h2>
          <p className="mt-3 text-sm sm:text-base text-muted-foreground">
            Traditional South Indian recipes meet sprouted-grain science — every batch
            made fresh in our home kitchen.
          </p>
        </motion.div>

        <div className="grid grid-cols-12 gap-5">
          {CARDS.map((card, i) => (
            <motion.article
              key={card.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative overflow-hidden rounded-3xl ${card.span} ${card.cls}`}
              data-testid={`bento-card-${i}`}
            >
              <img
                src={card.img}
                alt={card.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover opacity-25 transition-all duration-700 group-hover:scale-105 group-hover:opacity-35"
              />
              <div className="relative flex h-full min-h-[240px] md:min-h-[280px] flex-col justify-end p-7 sm:p-9">
                <h3 className="font-display text-xl sm:text-2xl font-semibold">{card.title}</h3>
                <p className="mt-2 max-w-md text-sm leading-relaxed opacity-80">{card.desc}</p>
              </div>
            </motion.article>
          ))}

          <motion.article
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.36, ease: [0.22, 1, 0.36, 1] }}
            className="col-span-12 md:col-span-4 flex min-h-[200px] flex-col justify-end rounded-3xl bg-terracotta p-7 sm:p-9 text-white"
            data-testid="bento-card-3"
          >
            <p className="font-display text-4xl font-bold">0%</p>
            <h3 className="mt-1 font-display text-xl font-semibold">Preservatives, guaranteed</h3>
            <p className="mt-2 text-sm leading-relaxed text-white/85">
              Prepared fresh only after your order is confirmed, in our hygienic home kitchen.
            </p>
          </motion.article>
        </div>
      </div>
    </section>
  );
}
